/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, August 2022
 * @format
 * @flow
 */

import { REHYDRATE } from 'redux-persist';
import { ActionTypes } from '../constants';

const defaults = {
  orderStatusFilters: [],
  odOrderTypeFilters: [],
  posOrderTypeFilter: [],
  revenueCenterTypeFilter: [],
  sensorGroupTypeFilter: [],
};

export interface CacheState {
  orderStatusFilters: Array;
  orderTypeFilters: Array
}

export interface ActionType {
  type: string;
  payload: any;
}

export default (state = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.UPDATE_FB_CHECK_FILTERS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case REHYDRATE: {
      if (
        action.payload &&
        action.payload.fbCheckFilters
      ) {
        return { ...state, ...action.payload.fbCheckFilters };
      }
      return { ...defaults };
    }
    default:
      return { ...state };
  }
};
